<div class="user-pill border-radius-5" *ngIf="account">
     <i class="fa-light fa-user"></i>
    <div class="size-1"></div>
    <div class="text-small">{{displayName}}</div>
</div>
